<div class="chart">
  <div
    class="chartTitle"
    [ngClass]="[!hasEdit ? 'preview' : '']"
    *ngIf="!preview"
  >
    <div
      class="title"
      style="height: 30px; width: 85%"
      matTooltip="{{ title }}"
      matTooltipPosition="right"
    >
      {{ title }}
    </div>
    <fa-icon
      [icon]="faCircleInfo"
      class="pencil tableInfoIcon"
      *ngIf="description"
      matTooltip="Description: {{ description }}"
      matTooltipPosition="right"
      matTooltipClass="report-home-tooltip"
    ></fa-icon>
  </div>
  <div class="chartTitle" *ngIf="preview">
    <div
      class="title"
      style="height: 30px; width: 85%; margin-left: -30px"
      matTooltip="{{ title }}"
      matTooltipPosition="right"
    >
      {{ title }}
    </div>
    <fa-icon
      [icon]="faCircleInfo"
      class="pencil tableInfoIcon"
      *ngIf="description"
      matTooltip="Description: {{ description }}"
      matTooltipPosition="right"
      matTooltipClass="report-home-tooltip"
    ></fa-icon>
  </div>
  <ng-container *ngIf="!data || data.length <= 0">
    <div class="noData">
      <span class="blank_img">
        <fa-icon [icon]="faTable"></fa-icon>
        <ng-container *ngIf="hasEdit">
          <div
            *ngIf="
              (!preview || hasEdit) &&
              dataPoints.data &&
              dataPoints.data.length <= 0
            "
          >
            Choose one or more fields to display in the table
          </div>
          <div
            *ngIf="dataPoints && dataPoints.data && dataPoints.data.length >= 1"
          >
            There is no data to display<br />
            Review Chart Settings or Filters if this is unexpected
          </div>
          <div
            *ngIf="preview && dataPoints.data && dataPoints.data.length <= 0"
          >
            No visible fields to display
          </div></ng-container
        ></span
      >
    </div>
  </ng-container>
  <ng-container *ngIf="data && data.length > 0">
    <mat-table
      #table
      [dataSource]="dataSource"
      [ngStyle]="{ 'max-height': fullSize ? '80%' : '500px' }"
    >
      <div>
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
      </div>

      <ng-container
        *ngFor="let column of displayedColumns; let colIndex = index"
        [matColumnDef]="column"
      >
        <ng-container *ngIf="displayedHeaderColumns[0] == 'referenceLink'">
          <ng-container *ngIf="colIndex == 0">
            <mat-header-cell *matHeaderCellDef class="drilldown">
            </mat-header-cell>
            <mat-cell *matCellDef="let item" class="drilldown">
              <ng-container *ngIf="item[column].value">
                <a href="{{ item[column].value }}" target="_blank"
                  ><fa-icon [icon]="faEdit"></fa-icon
                ></a>
              </ng-container>
            </mat-cell>
          </ng-container>
          <ng-container *ngIf="colIndex != 0">
            <mat-header-cell
              *matHeaderCellDef
              mwlResizable
              [enableGhostResize]="false"
              (resizeEnd)="onResizeEnd($event, column)"
            >
              {{ displayedHeaderColumns[colIndex] }}
              <div
                class="resize-handle-right"
                mwlResizeHandle
                [resizeEdges]="{ right: true }"
              >
                <fa-icon [icon]="faGripLinesVertical"></fa-icon>
              </div>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let item"
              [ngStyle]="{
                'background-color': item[column].color,
                color: item[column].textColor
              }"
            >
              <div
                class="fixUL"
                [innerHtml]="item[column].value || '&nbsp;' | safeHtml"
              ></div>
            </mat-cell>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="displayedHeaderColumns[0] != 'referenceLink'">
          <mat-header-cell
            *matHeaderCellDef
            mwlResizable
            [enableGhostResize]="false"
            (resizeEnd)="onResizeEnd($event, column)"
          >
            {{ displayedHeaderColumns[colIndex] }}
            <div
              class="resize-handle-right"
              mwlResizeHandle
              [resizeEdges]="{ right: true }"
            >
              <fa-icon [icon]="faGripLinesVertical"></fa-icon>
            </div>
          </mat-header-cell>

          <mat-cell
            *matCellDef="let item"
            [ngStyle]="{
              'background-color': item[column].color,
              color: item[column].textColor
            }"
          >
            <div
              class="fixUL"
              [innerHtml]="item[column].value || '&nbsp;' | safeHtml"
            ></div>
          </mat-cell>
        </ng-container>
      </ng-container>
      <mat-row
        matRipple
        id="row-{{ index }}"
        *matRowDef="let row; columns: displayedColumns; let index = index"
      >
      </mat-row>
    </mat-table>
  </ng-container>

  <div class="paginator" [hidden]="!data || data.length <= 0">
    <form [formGroup]="dataForm" class="dataSearchForm">
      <mat-form-field appearance="outline">
        <fa-icon
          [icon]="faSearch"
          matPrefix
          mat-button
          style="margin-right: 10px"
        ></fa-icon>
        <input
          matInput
          placeholder="Search for a Field"
          name="dataSearch"
          formControlName="dataSearch"
          aria-label="Search for a Field"
          (keyup)="applyFilter($event)"
        /><label for="dataSearch"></label>
      </mat-form-field>
    </form>

    <mat-paginator
      [pageSize]="50"
      [pageSizeOptions]="[5, 10, 20, 50, 100, 500]"
      showFirstLastButtons
      (page)="resizeData()"
      formFieldAppearance="none"
    ></mat-paginator>
  </div>
</div>
